(function () {
  'use strict';

  // Gallery: thumbnail click swaps main image
  document.querySelectorAll('[id^="ts-pdp-thumbs-"]').forEach(function (thumbsEl) {
    thumbsEl.querySelectorAll('.ts-pdp__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const mainImg = document.getElementById(thumb.dataset.target);
        if (mainImg) mainImg.src = thumb.dataset.src;
        thumbsEl.querySelectorAll('.ts-pdp__thumb').forEach(function (t) {
          t.classList.remove('ts-pdp__thumb--active');
        });
        thumb.classList.add('ts-pdp__thumb--active');
      });
    });
  });

  // Quantity ± buttons
  document.querySelectorAll('.ts-pdp__qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = btn.closest('.ts-pdp__qty').querySelector('.ts-pdp__qty-input');
      if (!input) return;
      const val = parseInt(input.value, 10) || 1;
      const min = parseInt(input.min, 10) || 1;
      const max = parseInt(input.max, 10) || 999;
      input.value = btn.dataset.action === 'plus' ? Math.min(max, val + 1) : Math.max(min, val - 1);
    });
  });

  // Tab navigation
  document.querySelectorAll('[id^="ts-pdp-tabs-"]').forEach(function (tabsEl) {
    const buttons = tabsEl.querySelectorAll('.ts-pdp__tab-btn');
    const panels = tabsEl.querySelectorAll('.ts-pdp__tab-panel');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const target = btn.dataset.tab;
        buttons.forEach(function (b) {
          b.classList.remove('ts-pdp__tab-btn--active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('ts-pdp__tab-btn--active');
        btn.setAttribute('aria-selected', 'true');
        panels.forEach(function (panel) {
          panel.classList.toggle('ts-pdp__tab-panel--hidden', panel.id !== 'ts-tab-' + target);
        });
      });
    });
  });

  // Share button (Web Share API with clipboard fallback)
  document.querySelectorAll('.ts-pdp-share-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (navigator.share) {
        navigator.share({ title: document.title, url: window.location.href }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href);
      }
    });
  });


  // Quote button handler (delegates to ts-plp-actions.js global handler if loaded,
  // otherwise handles it here for PDP context)
  document.querySelectorAll('.ts-pdp__secondary-actions .ts-pdp-action-link--quote').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const variantId = btn.dataset.variantId;
      const sku       = btn.dataset.variantSku;
      const title     = btn.dataset.productTitle;
      const price     = btn.dataset.tradePrice;
      if (typeof window.tsAddToQuote === 'function') {
        window.tsAddToQuote(variantId, sku, title, price);
      }
    });
  });

})();
